export default IconMusicPause => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-music-pause" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M3 17a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
  <path d="M9 17v-13h10v9" />
  <path d="M9 8h10" />
  <path d="M17 17v5" />
  <path d="M21 17v5" />
</svg>`;